import apiService from '../api/apiService';

export const triggerImageDeletionFromUrl = (
  imageUrl: string,
  warningMessage: string
) => {
  const filePath = apiService._extractFilePathFromImageUrl(imageUrl);

  if (filePath) {
    apiService._triggerImageDelete(filePath);
    return true;
  }

  console.warn(warningMessage, imageUrl);
  return false;
};

